import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileMp4.tsx
const IconFileMp4 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#4398e6",
			fillRule: "evenodd",
			d: "M10 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm5.016 1.9v4.188h.912v-1.512h1.068q.294 0 .528-.096.234-.102.396-.276.168-.174.258-.42t.09-.546q0-.294-.09-.54a1.2 1.2 0 0 0-.258-.426 1.1 1.1 0 0 0-.396-.27 1.3 1.3 0 0 0-.528-.102zm.912 1.884h.96a.46.46 0 0 0 .318-.102q.12-.108.12-.312v-.264q0-.204-.12-.306a.44.44 0 0 0-.318-.108h-.96zm4.586 2.304v-.804h-1.842v-.768l1.632-2.616h1.068v2.688h.528v.696h-.528v.804zm0-1.5h-1.122l1.062-1.758h.06zm-7.3-1.248h.018v2.748h.858V10.9h-.972l-1.014 1.962h-.012L11.066 10.9H10.1v4.188h.858v-2.79h.018l.318.66.798 1.476.816-1.482z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		})
	]
});
var IconFileMp4_default = forwardRef(IconFileMp4);
//#endregion
export { IconFileMp4_default as default };
